// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2nHQs","list":"BalanceDue_list__3HcTr","listRow":"BalanceDue_listRow__1AIri","total":"BalanceDue_total__3s00c"};